import ShortAnswer from './shorts';
import EssayWriting from './essay';
import OptionlessFillBlank from './OptionlessFib';
import QuestionAndAnswer from './qna';
import WritingPractice from './WritingPractice';

export {
  ShortAnswer,
  EssayWriting,
  OptionlessFillBlank,
  QuestionAndAnswer
};

export default WritingPractice;

